import { createSelector } from 'reselect'
import { get } from 'lodash'
import { isBefore } from 'date-fns'
import { withoutRemovedRooms } from '../../bookingCalendar/selectors/rooms'
import { validLicenses } from './license'

export const getRoomLimit = createSelector(
  [validLicenses],
  licenses => {
    const limit = licenses
      .filter(l => isBefore(l.startLicense, new Date()))
      .reduce((acc, lic) => {
        return Math.max(acc, get(lic, 'roomLimit.limit', 0))
      }, 0)
    return limit || 9999
  },
)

export const isAtMaxRooms = createSelector(
  [getRoomLimit, withoutRemovedRooms],
  // (roomLimit, rooms) => roomLimit <= rooms.length,
  (roomLimit, rooms) => roomLimit <= rooms.length,
)
